// Generated on 2025-11-24T21:56:15.107Z
// This file contains preloaded top vehicle data from the API
// Do not edit manually - use 'npm run generate:top-vehicles-data' to regenerate

export const preloadedTopVehicles: any = [
  {
    "marca": "FORD",
    "modelo": "ESCAPE",
    "busquedas": "51405"
  },
  {
    "marca": "HONDA",
    "modelo": "CR-V",
    "busquedas": "50099"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA",
    "busquedas": "46120"
  },
  {
    "marca": "HONDA",
    "modelo": "CIVIC",
    "busquedas": "38639"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA",
    "busquedas": "34088"
  },
  {
    "marca": "KIA",
    "modelo": "SORENTO",
    "busquedas": "16207"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TACOMA",
    "busquedas": "14059"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER",
    "busquedas": "12707"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER",
    "busquedas": "12054"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "L200",
    "busquedas": "10846"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HILUX",
    "busquedas": "10810"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RAV4",
    "busquedas": "9730"
  },
  {
    "marca": "FORD",
    "modelo": "RANGER",
    "busquedas": "8764"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER NP300 D23",
    "busquedas": "7305"
  },
  {
    "marca": "JEEP",
    "modelo": "PATRIOT",
    "busquedas": "6849"
  },
  {
    "marca": "FORD",
    "modelo": "FOCUS",
    "busquedas": "6106"
  },
  {
    "marca": "TOYOTA",
    "modelo": "4RUNNER",
    "busquedas": "5909"
  },
  {
    "marca": "ISUZU",
    "modelo": "D-MAX",
    "busquedas": "5820"
  },
  {
    "marca": "NISSAN",
    "modelo": "SENTRA",
    "busquedas": "5743"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE",
    "busquedas": "5593"
  },
  {
    "marca": "PONTIAC",
    "modelo": "VIBE",
    "busquedas": "4669"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PICKUP",
    "busquedas": "4621"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "LANCER",
    "busquedas": "4548"
  },
  {
    "marca": "KIA",
    "modelo": "SPORTAGE",
    "busquedas": "4410"
  },
  {
    "marca": "HONDA",
    "modelo": "FIT",
    "busquedas": "4332"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER D22",
    "busquedas": "4161"
  },
  {
    "marca": "MAZDA",
    "modelo": "BT-50",
    "busquedas": "4107"
  },
  {
    "marca": "FORD",
    "modelo": "F-150",
    "busquedas": "4024"
  },
  {
    "marca": "HONDA",
    "modelo": "PILOT",
    "busquedas": "3848"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ACCENT",
    "busquedas": "3828"
  },
  {
    "marca": "HONDA",
    "modelo": "ACCORD",
    "busquedas": "3422"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TUCSON",
    "busquedas": "3331"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE",
    "busquedas": "3233"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "COLORADO",
    "busquedas": "3191"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER PRADO",
    "busquedas": "3010"
  },
  {
    "marca": "MAZDA",
    "modelo": "3",
    "busquedas": "2699"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATHFINDER",
    "busquedas": "2449"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MATRIX",
    "busquedas": "2411"
  },
  {
    "marca": "JEEP",
    "modelo": "WRANGLER",
    "busquedas": "2301"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK",
    "busquedas": "2261"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HIACE",
    "busquedas": "2147"
  },
  {
    "marca": "KIA",
    "modelo": "RIO",
    "busquedas": "2119"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER",
    "busquedas": "2062"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO SPORT",
    "busquedas": "2004"
  },
  {
    "marca": "TOYOTA",
    "modelo": "YARIS",
    "busquedas": "1893"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CAMRY",
    "busquedas": "1717"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE SPORT",
    "busquedas": "1669"
  },
  {
    "marca": "NISSAN",
    "modelo": "ALTIMA",
    "busquedas": "1623"
  },
  {
    "marca": "MAZDA",
    "modelo": "TRIBUTE",
    "busquedas": "1549"
  },
  {
    "marca": "NISSAN",
    "modelo": "VERSA",
    "busquedas": "1531"
  },
  {
    "marca": "KIA",
    "modelo": "SPECTRA",
    "busquedas": "1517"
  },
  {
    "marca": "HONDA",
    "modelo": "ODYSSEY",
    "busquedas": "1506"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CRUZE",
    "busquedas": "1492"
  },
  {
    "marca": "JEEP",
    "modelo": "COMPASS",
    "busquedas": "1487"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "AMAROK",
    "busquedas": "1452"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TERCEL",
    "busquedas": "1414"
  },
  {
    "marca": "MAZDA",
    "modelo": "PROTEGE",
    "busquedas": "1397"
  },
  {
    "marca": "JEEP",
    "modelo": "CHEROKEE",
    "busquedas": "1364"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER SPORT",
    "busquedas": "1275"
  },
  {
    "marca": "NISSAN",
    "modelo": "NAVARA D40",
    "busquedas": "1270"
  },
  {
    "marca": "JEEP",
    "modelo": "GRAND CHEROKEE",
    "busquedas": "1115"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIRAGE",
    "busquedas": "1103"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TUNDRA",
    "busquedas": "1074"
  },
  {
    "marca": "FORD",
    "modelo": "EDGE",
    "busquedas": "1062"
  },
  {
    "marca": "MAZDA",
    "modelo": "6",
    "busquedas": "1048"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "H-100",
    "busquedas": "1036"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TAHOE",
    "busquedas": "1032"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SIENNA",
    "busquedas": "995"
  },
  {
    "marca": "BMW",
    "modelo": "X3",
    "busquedas": "989"
  },
  {
    "marca": "KIA",
    "modelo": "SOUL",
    "busquedas": "987"
  },
  {
    "marca": "ISUZU",
    "modelo": "RODEO",
    "busquedas": "983"
  },
  {
    "marca": "HONDA",
    "modelo": "HR-V",
    "busquedas": "956"
  },
  {
    "marca": "KIA",
    "modelo": "PICANTO",
    "busquedas": "896"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HIGHLANDER",
    "busquedas": "888"
  },
  {
    "marca": "KIA",
    "modelo": "SEPHIA",
    "busquedas": "857"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO",
    "busquedas": "854"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAX",
    "busquedas": "851"
  },
  {
    "marca": "NISSAN",
    "modelo": "XTERRA",
    "busquedas": "832"
  },
  {
    "marca": "DODGE",
    "modelo": "NEON",
    "busquedas": "798"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2900",
    "busquedas": "796"
  },
  {
    "marca": "NISSAN",
    "modelo": "PICKUP",
    "busquedas": "791"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "GALANT",
    "busquedas": "785"
  },
  {
    "marca": "NISSAN",
    "modelo": "QASHQAI",
    "busquedas": "783"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "S10",
    "busquedas": "764"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVEO",
    "busquedas": "754"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500",
    "busquedas": "750"
  },
  {
    "marca": "HONDA",
    "modelo": "ELEMENT",
    "busquedas": "746"
  },
  {
    "marca": "FORD",
    "modelo": "EXPEDITION",
    "busquedas": "745"
  },
  {
    "marca": "NISSAN",
    "modelo": "D21",
    "busquedas": "739"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SONATA",
    "busquedas": "738"
  },
  {
    "marca": "NISSAN",
    "modelo": "URVAN",
    "busquedas": "737"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER",
    "busquedas": "717"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "NATIVA",
    "busquedas": "712"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2500",
    "busquedas": "698"
  },
  {
    "marca": "BMW",
    "modelo": "X5",
    "busquedas": "682"
  },
  {
    "marca": "FORD",
    "modelo": "MUSTANG",
    "busquedas": "637"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EQUINOX",
    "busquedas": "622"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATROL",
    "busquedas": "613"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER",
    "busquedas": "613"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRAND STAREX",
    "busquedas": "576"
  },
  {
    "marca": "BMW",
    "modelo": "328I",
    "busquedas": "548"
  },
  {
    "marca": "ISUZU",
    "modelo": "PICKUP KB",
    "busquedas": "520"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-7",
    "busquedas": "507"
  },
  {
    "marca": "SUZUKI",
    "modelo": "GRAND VITARA",
    "busquedas": "505"
  },
  {
    "marca": "NISSAN",
    "modelo": "X-TRAIL",
    "busquedas": "500"
  },
  {
    "marca": "FORD",
    "modelo": "F-250 SUPER DUTY",
    "busquedas": "471"
  },
  {
    "marca": "RAM",
    "modelo": "1500",
    "busquedas": "448"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRACKER",
    "busquedas": "437"
  },
  {
    "marca": "HONDA",
    "modelo": "RIDGELINE",
    "busquedas": "418"
  },
  {
    "marca": "JEEP",
    "modelo": "LIBERTY",
    "busquedas": "402"
  },
  {
    "marca": "MAZDA",
    "modelo": "BT-50 PRO",
    "busquedas": "393"
  },
  {
    "marca": "DODGE",
    "modelo": "DAKOTA",
    "busquedas": "388"
  },
  {
    "marca": "MERCURY",
    "modelo": "MARINER",
    "busquedas": "386"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "I10",
    "busquedas": "385"
  },
  {
    "marca": "MAZDA",
    "modelo": "626",
    "busquedas": "381"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2200",
    "busquedas": "381"
  },
  {
    "marca": "NISSAN",
    "modelo": "NV200",
    "busquedas": "370"
  },
  {
    "marca": "FORD",
    "modelo": "ESCORT",
    "busquedas": "368"
  },
  {
    "marca": "NISSAN",
    "modelo": "MURANO",
    "busquedas": "357"
  },
  {
    "marca": "NISSAN",
    "modelo": "TIIDA",
    "busquedas": "353"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SONIC",
    "busquedas": "352"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "JETTA",
    "busquedas": "352"
  },
  {
    "marca": "MAZDA",
    "modelo": "323",
    "busquedas": "350"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 2500",
    "busquedas": "338"
  },
  {
    "marca": "TOYOTA",
    "modelo": "ECHO",
    "busquedas": "324"
  },
  {
    "marca": "MAZDA",
    "modelo": "2",
    "busquedas": "318"
  },
  {
    "marca": "GMC",
    "modelo": "CANYON",
    "busquedas": "317"
  },
  {
    "marca": "FORD",
    "modelo": "FIESTA",
    "busquedas": "310"
  },
  {
    "marca": "NISSAN",
    "modelo": "URVAN NV350",
    "busquedas": "306"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "EON",
    "busquedas": "303"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 1500",
    "busquedas": "293"
  },
  {
    "marca": "DODGE",
    "modelo": "CARAVAN",
    "busquedas": "287"
  },
  {
    "marca": "ISUZU",
    "modelo": "PICKUP",
    "busquedas": "283"
  },
  {
    "marca": "JEEP",
    "modelo": "RENEGADE",
    "busquedas": "281"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER SPORT TRAC",
    "busquedas": "278"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "L300",
    "busquedas": "277"
  },
  {
    "marca": "NISSAN",
    "modelo": "JUKE",
    "busquedas": "277"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ECLIPSE",
    "busquedas": "270"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TIBURON",
    "busquedas": "269"
  },
  {
    "marca": "NISSAN",
    "modelo": "KICKS",
    "busquedas": "263"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-5",
    "busquedas": "257"
  },
  {
    "marca": "BMW",
    "modelo": "325I",
    "busquedas": "254"
  },
  {
    "marca": "SCION",
    "modelo": "XB",
    "busquedas": "252"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CELICA",
    "busquedas": "248"
  },
  {
    "marca": "SUBARU",
    "modelo": "FORESTER",
    "busquedas": "242"
  },
  {
    "marca": "DODGE",
    "modelo": "GRAND CARAVAN",
    "busquedas": "230"
  },
  {
    "marca": "SUZUKI",
    "modelo": "ESTEEM",
    "busquedas": "230"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "PRIZM",
    "busquedas": "227"
  },
  {
    "marca": "SUZUKI",
    "modelo": "VITARA",
    "busquedas": "223"
  },
  {
    "marca": "TOYOTA",
    "modelo": "FORTUNER",
    "busquedas": "219"
  },
  {
    "marca": "SCION",
    "modelo": "XA",
    "busquedas": "216"
  },
  {
    "marca": "SUZUKI",
    "modelo": "FORENZA",
    "busquedas": "213"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2300",
    "busquedas": "213"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT CONNECT",
    "busquedas": "208"
  },
  {
    "marca": "NISSAN",
    "modelo": "NP300",
    "busquedas": "207"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TIGUAN",
    "busquedas": "206"
  },
  {
    "marca": "NISSAN",
    "modelo": "350Z",
    "busquedas": "206"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE",
    "busquedas": "204"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVALANCHE",
    "busquedas": "203"
  },
  {
    "marca": "KIA",
    "modelo": "OPTIMA",
    "busquedas": "201"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAPTIVA",
    "busquedas": "200"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "H-1",
    "busquedas": "196"
  },
  {
    "marca": "ACURA",
    "modelo": "RDX",
    "busquedas": "194"
  },
  {
    "marca": "FORD",
    "modelo": "FUSION",
    "busquedas": "191"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SX4",
    "busquedas": "187"
  },
  {
    "marca": "NISSAN",
    "modelo": "ARMADA",
    "busquedas": "176"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ENDEAVOR",
    "busquedas": "170"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SEQUOIA",
    "busquedas": "165"
  },
  {
    "marca": "HUMMER",
    "modelo": "H3",
    "busquedas": "160"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRAND I10",
    "busquedas": "158"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SWIFT",
    "busquedas": "158"
  },
  {
    "marca": "SUZUKI",
    "modelo": "AERIO",
    "busquedas": "158"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VELOSTER",
    "busquedas": "157"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SIDEKICK",
    "busquedas": "157"
  },
  {
    "marca": "FORD",
    "modelo": "ECOSPORT",
    "busquedas": "155"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-9",
    "busquedas": "153"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAMARO",
    "busquedas": "152"
  },
  {
    "marca": "RAM",
    "modelo": "2500",
    "busquedas": "150"
  },
  {
    "marca": "SCION",
    "modelo": "XD",
    "busquedas": "149"
  },
  {
    "marca": "NISSAN",
    "modelo": "720",
    "busquedas": "147"
  },
  {
    "marca": "SUBARU",
    "modelo": "OUTBACK",
    "busquedas": "146"
  },
  {
    "marca": "ACURA",
    "modelo": "TL",
    "busquedas": "145"
  },
  {
    "marca": "DODGE",
    "modelo": "DART",
    "busquedas": "144"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "CRETA",
    "busquedas": "143"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAVALIER",
    "busquedas": "135"
  },
  {
    "marca": "ACURA",
    "modelo": "TSX",
    "busquedas": "133"
  },
  {
    "marca": "BMW",
    "modelo": "Z4",
    "busquedas": "132"
  },
  {
    "marca": "MAZDA",
    "modelo": "PROTEGE5",
    "busquedas": "129"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2000",
    "busquedas": "128"
  },
  {
    "marca": "DODGE",
    "modelo": "CALIBER",
    "busquedas": "124"
  },
  {
    "marca": "NISSAN",
    "modelo": "TITAN",
    "busquedas": "123"
  },
  {
    "marca": "SUBARU",
    "modelo": "IMPREZA",
    "busquedas": "117"
  },
  {
    "marca": "SATURN",
    "modelo": "VUE",
    "busquedas": "115"
  },
  {
    "marca": "SUBARU",
    "modelo": "LEGACY",
    "busquedas": "114"
  },
  {
    "marca": "ISUZU",
    "modelo": "TROOPER",
    "busquedas": "112"
  },
  {
    "marca": "DODGE",
    "modelo": "JOURNEY",
    "busquedas": "112"
  },
  {
    "marca": "MAZDA",
    "modelo": "5",
    "busquedas": "111"
  },
  {
    "marca": "ACURA",
    "modelo": "RSX",
    "busquedas": "109"
  },
  {
    "marca": "BMW",
    "modelo": "X1",
    "busquedas": "109"
  },
  {
    "marca": "FORD",
    "modelo": "F-350 SUPER DUTY",
    "busquedas": "108"
  },
  {
    "marca": "TOYOTA",
    "modelo": "T100",
    "busquedas": "107"
  },
  {
    "marca": "NISSAN",
    "modelo": "QUEST",
    "busquedas": "107"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "PT CRUISER",
    "busquedas": "105"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 3500",
    "busquedas": "105"
  },
  {
    "marca": "NISSAN",
    "modelo": "MAXIMA",
    "busquedas": "104"
  },
  {
    "marca": "SUZUKI",
    "modelo": "APV",
    "busquedas": "101"
  },
  {
    "marca": "ISUZU",
    "modelo": "MU-X",
    "busquedas": "98"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TERRACAN",
    "busquedas": "98"
  },
  {
    "marca": "SCION",
    "modelo": "TC",
    "busquedas": "97"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "N300",
    "busquedas": "94"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX300",
    "busquedas": "92"
  },
  {
    "marca": "GEO",
    "modelo": "PRIZM",
    "busquedas": "90"
  },
  {
    "marca": "DODGE",
    "modelo": "DURANGO",
    "busquedas": "89"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "BLAZER",
    "busquedas": "87"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "PASSAT",
    "busquedas": "87"
  },
  {
    "marca": "ACURA",
    "modelo": "MDX",
    "busquedas": "87"
  },
  {
    "marca": "MAZDA",
    "modelo": "MPV",
    "busquedas": "86"
  },
  {
    "marca": "NISSAN",
    "modelo": "NV350 URVAN",
    "busquedas": "86"
  },
  {
    "marca": "LEXUS",
    "modelo": "GX470",
    "busquedas": "85"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 1500",
    "busquedas": "83"
  },
  {
    "marca": "BMW",
    "modelo": "335I",
    "busquedas": "83"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VERACRUZ",
    "busquedas": "81"
  },
  {
    "marca": "BMW",
    "modelo": "X6",
    "busquedas": "79"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "MATRIX",
    "busquedas": "79"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "METRO",
    "busquedas": "79"
  },
  {
    "marca": "SUZUKI",
    "modelo": "JIMNY",
    "busquedas": "78"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN",
    "busquedas": "78"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAPTIVA SPORT",
    "busquedas": "76"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA GT",
    "busquedas": "76"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 1500",
    "busquedas": "75"
  },
  {
    "marca": "NISSAN",
    "modelo": "ALMERA",
    "busquedas": "74"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MALIBU",
    "busquedas": "73"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER COUNTRYMAN",
    "busquedas": "72"
  },
  {
    "marca": "VOLVO",
    "modelo": "S60",
    "busquedas": "72"
  },
  {
    "marca": "ACURA",
    "modelo": "ILX",
    "busquedas": "72"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX60",
    "busquedas": "71"
  },
  {
    "marca": "HONDA",
    "modelo": "CITY",
    "busquedas": "70"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "BEAT",
    "busquedas": "69"
  },
  {
    "marca": "CADILLAC",
    "modelo": "ESCALADE",
    "busquedas": "68"
  },
  {
    "marca": "BMW",
    "modelo": "328I XDRIVE",
    "busquedas": "67"
  },
  {
    "marca": "AUDI",
    "modelo": "Q7",
    "busquedas": "67"
  },
  {
    "marca": "ACURA",
    "modelo": "INTEGRA",
    "busquedas": "67"
  },
  {
    "marca": "RAM",
    "modelo": "3500",
    "busquedas": "67"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER PICKUP",
    "busquedas": "66"
  },
  {
    "marca": "TOYOTA",
    "modelo": "FJ CRUISER",
    "busquedas": "65"
  },
  {
    "marca": "FORD",
    "modelo": "TAURUS",
    "busquedas": "65"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAVERSE",
    "busquedas": "64"
  },
  {
    "marca": "BMW",
    "modelo": "528I",
    "busquedas": "64"
  },
  {
    "marca": "DODGE",
    "modelo": "AVENGER",
    "busquedas": "63"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "TOWN & COUNTRY",
    "busquedas": "63"
  },
  {
    "marca": "PORSCHE",
    "modelo": "CAYENNE",
    "busquedas": "62"
  },
  {
    "marca": "JEEP",
    "modelo": "GLADIATOR",
    "busquedas": "61"
  },
  {
    "marca": "FORD",
    "modelo": "F-250",
    "busquedas": "58"
  },
  {
    "marca": "MAZDA",
    "modelo": "B3000",
    "busquedas": "57"
  },
  {
    "marca": "VOLVO",
    "modelo": "S40",
    "busquedas": "57"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TOUAREG",
    "busquedas": "54"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SAMURAI",
    "busquedas": "53"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC90",
    "busquedas": "52"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "STAREX",
    "busquedas": "52"
  },
  {
    "marca": "GMC",
    "modelo": "ACADIA",
    "busquedas": "52"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AVALON",
    "busquedas": "50"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500 HD",
    "busquedas": "50"
  },
  {
    "marca": "GMC",
    "modelo": "SONOMA",
    "busquedas": "49"
  },
  {
    "marca": "SUZUKI",
    "modelo": "XL-7",
    "busquedas": "48"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "BEETLE",
    "busquedas": "47"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "OPTRA",
    "busquedas": "47"
  },
  {
    "marca": "KIA",
    "modelo": "SEDONA",
    "busquedas": "46"
  },
  {
    "marca": "AUDI",
    "modelo": "A4",
    "busquedas": "45"
  },
  {
    "marca": "KIA",
    "modelo": "PREGIO",
    "busquedas": "45"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AVENSIS",
    "busquedas": "45"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "COBALT",
    "busquedas": "44"
  },
  {
    "marca": "HONDA",
    "modelo": "PASSPORT",
    "busquedas": "44"
  },
  {
    "marca": "LINCOLN",
    "modelo": "MKX",
    "busquedas": "44"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "VENTURE",
    "busquedas": "43"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAILBLAZER",
    "busquedas": "42"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C230",
    "busquedas": "42"
  },
  {
    "marca": "GMC",
    "modelo": "TERRAIN",
    "busquedas": "40"
  },
  {
    "marca": "KIA",
    "modelo": "SPECTRA5",
    "busquedas": "40"
  },
  {
    "marca": "NISSAN",
    "modelo": "NP300 FRONTIER",
    "busquedas": "39"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CRESSIDA",
    "busquedas": "38"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "200",
    "busquedas": "38"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-290",
    "busquedas": "38"
  },
  {
    "marca": "ISUZU",
    "modelo": "RODEO SPORT",
    "busquedas": "38"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ATOS",
    "busquedas": "38"
  },
  {
    "marca": "GMC",
    "modelo": "ENVOY",
    "busquedas": "37"
  },
  {
    "marca": "BMW",
    "modelo": "330I",
    "busquedas": "37"
  },
  {
    "marca": "DODGE",
    "modelo": "NITRO",
    "busquedas": "36"
  },
  {
    "marca": "ISUZU",
    "modelo": "HOMBRE",
    "busquedas": "36"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRACE",
    "busquedas": "34"
  },
  {
    "marca": "GMC",
    "modelo": "YUKON",
    "busquedas": "34"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIRAGE G4",
    "busquedas": "34"
  },
  {
    "marca": "BMW",
    "modelo": "535I",
    "busquedas": "34"
  },
  {
    "marca": "LINCOLN",
    "modelo": "AVIATOR",
    "busquedas": "33"
  },
  {
    "marca": "BMW",
    "modelo": "320I",
    "busquedas": "33"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GENESIS COUPE",
    "busquedas": "33"
  },
  {
    "marca": "LEXUS",
    "modelo": "GX460",
    "busquedas": "33"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIGHTY MAX",
    "busquedas": "33"
  },
  {
    "marca": "BMW",
    "modelo": "325CI",
    "busquedas": "33"
  },
  {
    "marca": "GEO",
    "modelo": "METRO",
    "busquedas": "32"
  },
  {
    "marca": "FIAT",
    "modelo": "500",
    "busquedas": "32"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DISCOVERY",
    "busquedas": "31"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "IMPALA",
    "busquedas": "31"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVALANCHE 1500",
    "busquedas": "31"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOLF",
    "busquedas": "31"
  },
  {
    "marca": "BMW",
    "modelo": "330CI",
    "busquedas": "30"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "N400",
    "busquedas": "30"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "RAIDER",
    "busquedas": "30"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "PACIFICA",
    "busquedas": "30"
  },
  {
    "marca": "PONTIAC",
    "modelo": "SOLSTICE",
    "busquedas": "30"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX4",
    "busquedas": "30"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE SPORT",
    "busquedas": "30"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2600",
    "busquedas": "30"
  },
  {
    "marca": "DODGE",
    "modelo": "CHARGER",
    "busquedas": "30"
  },
  {
    "marca": "FORD",
    "modelo": "FLEX",
    "busquedas": "29"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "HHR",
    "busquedas": "29"
  },
  {
    "marca": "BMW",
    "modelo": "128I",
    "busquedas": "28"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA COUPE",
    "busquedas": "28"
  },
  {
    "marca": "HONDA",
    "modelo": "CROSSTOUR",
    "busquedas": "28"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS",
    "busquedas": "28"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VENUE",
    "busquedas": "27"
  },
  {
    "marca": "INFINITI",
    "modelo": "FX35",
    "busquedas": "27"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E320",
    "busquedas": "27"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CC",
    "busquedas": "27"
  },
  {
    "marca": "BMW",
    "modelo": "Z3",
    "busquedas": "27"
  },
  {
    "marca": "SCION",
    "modelo": "IQ",
    "busquedas": "26"
  },
  {
    "marca": "HUMMER",
    "modelo": "H2",
    "busquedas": "26"
  },
  {
    "marca": "SUBARU",
    "modelo": "BAJA",
    "busquedas": "26"
  },
  {
    "marca": "LINCOLN",
    "modelo": "NAVIGATOR",
    "busquedas": "26"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 1500",
    "busquedas": "26"
  },
  {
    "marca": "BMW",
    "modelo": "323I",
    "busquedas": "26"
  },
  {
    "marca": "TOYOTA",
    "modelo": "STARLET",
    "busquedas": "25"
  },
  {
    "marca": "BMW",
    "modelo": "330XI",
    "busquedas": "25"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-280",
    "busquedas": "25"
  },
  {
    "marca": "SUZUKI",
    "modelo": "CELERIO",
    "busquedas": "24"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 2500 HD",
    "busquedas": "23"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "300",
    "busquedas": "23"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML320",
    "busquedas": "23"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER",
    "busquedas": "23"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "POLO",
    "busquedas": "22"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "GROOVE",
    "busquedas": "22"
  },
  {
    "marca": "MAZDA",
    "modelo": "MIATA",
    "busquedas": "22"
  },
  {
    "marca": "FORD",
    "modelo": "EXCURSION",
    "busquedas": "22"
  },
  {
    "marca": "SUZUKI",
    "modelo": "EQUATOR",
    "busquedas": "22"
  },
  {
    "marca": "NISSAN",
    "modelo": "CUBE",
    "busquedas": "21"
  },
  {
    "marca": "MAZDA",
    "modelo": "B4000",
    "busquedas": "21"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 SUPER DUTY",
    "busquedas": "21"
  },
  {
    "marca": "DODGE",
    "modelo": "CHALLENGER",
    "busquedas": "21"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C250",
    "busquedas": "21"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GTI",
    "busquedas": "21"
  },
  {
    "marca": "AUDI",
    "modelo": "Q5",
    "busquedas": "20"
  },
  {
    "marca": "INFINITI",
    "modelo": "G35",
    "busquedas": "20"
  },
  {
    "marca": "BMW",
    "modelo": "525I",
    "busquedas": "20"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500",
    "busquedas": "20"
  },
  {
    "marca": "TOYOTA",
    "modelo": "URBAN CRUISER",
    "busquedas": "20"
  },
  {
    "marca": "FORD",
    "modelo": "WINDSTAR",
    "busquedas": "20"
  },
  {
    "marca": "BMW",
    "modelo": "530I",
    "busquedas": "19"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G6",
    "busquedas": "19"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TAOS",
    "busquedas": "19"
  },
  {
    "marca": "PONTIAC",
    "modelo": "TORRENT",
    "busquedas": "19"
  },
  {
    "marca": "BMW",
    "modelo": "325XI",
    "busquedas": "19"
  },
  {
    "marca": "RENAULT",
    "modelo": "KOLEOS",
    "busquedas": "19"
  },
  {
    "marca": "FORD",
    "modelo": "FREESTYLE",
    "busquedas": "19"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX470",
    "busquedas": "19"
  },
  {
    "marca": "ISUZU",
    "modelo": "AMIGO",
    "busquedas": "19"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO",
    "busquedas": "18"
  },
  {
    "marca": "NISSAN",
    "modelo": "240SX",
    "busquedas": "18"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS250",
    "busquedas": "18"
  },
  {
    "marca": "LEXUS",
    "modelo": "ES330",
    "busquedas": "18"
  },
  {
    "marca": "JAGUAR",
    "modelo": "X-TYPE",
    "busquedas": "18"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ENTOURAGE",
    "busquedas": "18"
  },
  {
    "marca": "SATURN",
    "modelo": "SL1",
    "busquedas": "17"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "EXCEL",
    "busquedas": "17"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS300",
    "busquedas": "17"
  },
  {
    "marca": "SATURN",
    "modelo": "SL2",
    "busquedas": "17"
  },
  {
    "marca": "BMW",
    "modelo": "318I",
    "busquedas": "17"
  },
  {
    "marca": "SUBARU",
    "modelo": "XV CROSSTREK",
    "busquedas": "16"
  },
  {
    "marca": "DAIHATSU",
    "modelo": "TERIOS",
    "busquedas": "16"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C300",
    "busquedas": "16"
  },
  {
    "marca": "FORD",
    "modelo": "FIGO",
    "busquedas": "16"
  },
  {
    "marca": "JEEP",
    "modelo": "COMMANDER",
    "busquedas": "16"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "VOYAGER",
    "busquedas": "16"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER SPORT",
    "busquedas": "15"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 2500",
    "busquedas": "15"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX350",
    "busquedas": "15"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-3",
    "busquedas": "15"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PREVIA",
    "busquedas": "15"
  },
  {
    "marca": "PORSCHE",
    "modelo": "BOXSTER",
    "busquedas": "15"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CORVETTE",
    "busquedas": "14"
  },
  {
    "marca": "HONDA",
    "modelo": "CR-Z",
    "busquedas": "14"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX56",
    "busquedas": "14"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ECLIPSE CROSS",
    "busquedas": "14"
  },
  {
    "marca": "AUDI",
    "modelo": "TT",
    "busquedas": "14"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-150",
    "busquedas": "14"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 3500",
    "busquedas": "14"
  },
  {
    "marca": "CADILLAC",
    "modelo": "SRX",
    "busquedas": "14"
  },
  {
    "marca": "KIA",
    "modelo": "CERATO",
    "busquedas": "14"
  },
  {
    "marca": "DAIHATSU",
    "modelo": "SIRION",
    "busquedas": "13"
  },
  {
    "marca": "MERCURY",
    "modelo": "TRACER",
    "busquedas": "13"
  },
  {
    "marca": "FORD",
    "modelo": "E-150",
    "busquedas": "13"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "SAVEIRO",
    "busquedas": "13"
  },
  {
    "marca": "DODGE",
    "modelo": "D350",
    "busquedas": "13"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CMV",
    "busquedas": "13"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CROSSFOX",
    "busquedas": "13"
  },
  {
    "marca": "TOYOTA",
    "modelo": "VAN",
    "busquedas": "13"
  },
  {
    "marca": "AUDI",
    "modelo": "S4",
    "busquedas": "13"
  },
  {
    "marca": "PONTIAC",
    "modelo": "SUNFIRE",
    "busquedas": "13"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER II",
    "busquedas": "13"
  },
  {
    "marca": "CADILLAC",
    "modelo": "ESCALADE ESV",
    "busquedas": "13"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO",
    "busquedas": "13"
  },
  {
    "marca": "BUICK",
    "modelo": "ENCORE",
    "busquedas": "13"
  },
  {
    "marca": "VOLVO",
    "modelo": "S80",
    "busquedas": "12"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATHFINDER ARMADA",
    "busquedas": "12"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "ASTRO",
    "busquedas": "12"
  },
  {
    "marca": "CADILLAC",
    "modelo": "CTS",
    "busquedas": "12"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "R350",
    "busquedas": "12"
  },
  {
    "marca": "INFINITI",
    "modelo": "JX35",
    "busquedas": "12"
  },
  {
    "marca": "FORD",
    "modelo": "CONTOUR",
    "busquedas": "12"
  },
  {
    "marca": "KIA",
    "modelo": "SELTOS",
    "busquedas": "12"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML350",
    "busquedas": "12"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO II",
    "busquedas": "12"
  },
  {
    "marca": "MERCURY",
    "modelo": "MOUNTAINEER",
    "busquedas": "12"
  },
  {
    "marca": "BMW",
    "modelo": "328XI",
    "busquedas": "12"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO IO",
    "busquedas": "12"
  },
  {
    "marca": "BMW",
    "modelo": "640I",
    "busquedas": "12"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "FREELANDER",
    "busquedas": "12"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX450",
    "busquedas": "11"
  },
  {
    "marca": "SUZUKI",
    "modelo": "RENO",
    "busquedas": "11"
  },
  {
    "marca": "SUBARU",
    "modelo": "CROSSTREK",
    "busquedas": "11"
  },
  {
    "marca": "BUICK",
    "modelo": "ENCLAVE",
    "busquedas": "11"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COASTER",
    "busquedas": "11"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "NEON",
    "busquedas": "11"
  },
  {
    "marca": "JMC",
    "modelo": "VIGUS",
    "busquedas": "11"
  },
  {
    "marca": "FORD",
    "modelo": "FREESTAR",
    "busquedas": "11"
  },
  {
    "marca": "GMC",
    "modelo": "SAFARI",
    "busquedas": "11"
  },
  {
    "marca": "KIA",
    "modelo": "CARNIVAL",
    "busquedas": "11"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-250",
    "busquedas": "11"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 3500 HD",
    "busquedas": "11"
  },
  {
    "marca": "KIA",
    "modelo": "RONDO",
    "busquedas": "11"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLK350",
    "busquedas": "11"
  },
  {
    "marca": "SUZUKI",
    "modelo": "IGNIS",
    "busquedas": "11"
  },
  {
    "marca": "KIA",
    "modelo": "SONET",
    "busquedas": "10"
  },
  {
    "marca": "GEO",
    "modelo": "TRACKER",
    "busquedas": "10"
  },
  {
    "marca": "KIA",
    "modelo": "CARENS",
    "busquedas": "10"
  },
  {
    "marca": "CADILLAC",
    "modelo": "XT5",
    "busquedas": "10"
  },
  {
    "marca": "DODGE",
    "modelo": "STRATUS",
    "busquedas": "10"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX330",
    "busquedas": "10"
  },
  {
    "marca": "SUZUKI",
    "modelo": "S-PRESSO",
    "busquedas": "10"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL450",
    "busquedas": "10"
  },
  {
    "marca": "VOLVO",
    "modelo": "C70",
    "busquedas": "10"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-MARK",
    "busquedas": "10"
  },
  {
    "marca": "LEXUS",
    "modelo": "ES300",
    "busquedas": "10"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX80",
    "busquedas": "10"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 ECONOLINE",
    "busquedas": "10"
  },
  {
    "marca": "MAZDA",
    "modelo": "RX-8",
    "busquedas": "10"
  },
  {
    "marca": "BMW",
    "modelo": "X4",
    "busquedas": "10"
  },
  {
    "marca": "RENAULT",
    "modelo": "CLIO",
    "busquedas": "10"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CITY EXPRESS",
    "busquedas": "9"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "SEBRING",
    "busquedas": "9"
  },
  {
    "marca": "BMW",
    "modelo": "325ES",
    "busquedas": "9"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR2",
    "busquedas": "9"
  },
  {
    "marca": "GMC",
    "modelo": "JIMMY",
    "busquedas": "9"
  },
  {
    "marca": "PORSCHE",
    "modelo": "MACAN",
    "busquedas": "9"
  },
  {
    "marca": "SUBARU",
    "modelo": "BRAT",
    "busquedas": "9"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RUSH",
    "busquedas": "9"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC70",
    "busquedas": "9"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE KOUP",
    "busquedas": "8"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E350",
    "busquedas": "8"
  },
  {
    "marca": "BMW",
    "modelo": "528I XDRIVE",
    "busquedas": "8"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-30",
    "busquedas": "8"
  },
  {
    "marca": "LEXUS",
    "modelo": "GS300",
    "busquedas": "8"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA",
    "busquedas": "8"
  },
  {
    "marca": "DAEWOO",
    "modelo": "LANOS",
    "busquedas": "8"
  },
  {
    "marca": "PORSCHE",
    "modelo": "PANAMERA",
    "busquedas": "8"
  },
  {
    "marca": "KIA",
    "modelo": "SOLUTO",
    "busquedas": "8"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 2500",
    "busquedas": "8"
  },
  {
    "marca": "SATURN",
    "modelo": "ION",
    "busquedas": "8"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C350",
    "busquedas": "7"
  },
  {
    "marca": "SUBARU",
    "modelo": "BRZ",
    "busquedas": "7"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER PHEV",
    "busquedas": "7"
  },
  {
    "marca": "BMW",
    "modelo": "318IS",
    "busquedas": "7"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ASX",
    "busquedas": "7"
  },
  {
    "marca": "VOLVO",
    "modelo": "S70",
    "busquedas": "7"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC60",
    "busquedas": "7"
  },
  {
    "marca": "GMC",
    "modelo": "S15",
    "busquedas": "7"
  },
  {
    "marca": "BMW",
    "modelo": "650I",
    "busquedas": "7"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MR2",
    "busquedas": "6"
  },
  {
    "marca": "NISSAN",
    "modelo": "QASHQAI+2",
    "busquedas": "6"
  },
  {
    "marca": "MASERATI",
    "modelo": "QUATTROPORTE",
    "busquedas": "6"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "PALISADE",
    "busquedas": "6"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 3500 VAN",
    "busquedas": "6"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 ECONOLINE CLUB WAGON",
    "busquedas": "6"
  },
  {
    "marca": "HONDA",
    "modelo": "S2000",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C320",
    "busquedas": "6"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SOLARA",
    "busquedas": "6"
  },
  {
    "marca": "NISSAN",
    "modelo": "TITAN XD",
    "busquedas": "6"
  },
  {
    "marca": "NISSAN",
    "modelo": "VERSA NOTE",
    "busquedas": "6"
  },
  {
    "marca": "LEXUS",
    "modelo": "LS400",
    "busquedas": "6"
  },
  {
    "marca": "HONDA",
    "modelo": "INSIGHT",
    "busquedas": "6"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-350",
    "busquedas": "6"
  },
  {
    "marca": "FORD",
    "modelo": "E-250",
    "busquedas": "6"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK CLASSIC",
    "busquedas": "6"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER SPORT",
    "busquedas": "6"
  },
  {
    "marca": "BUICK",
    "modelo": "RENDEZVOUS",
    "busquedas": "6"
  },
  {
    "marca": "RAM",
    "modelo": "700",
    "busquedas": "6"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "VOYAGER",
    "busquedas": "6"
  },
  {
    "marca": "TOYOTA",
    "modelo": "YARIS IA",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "300D",
    "busquedas": "6"
  },
  {
    "marca": "MAZDA",
    "modelo": "MX-5 MIATA",
    "busquedas": "5"
  },
  {
    "marca": "RAM",
    "modelo": "1500 CLASSIC",
    "busquedas": "5"
  },
  {
    "marca": "JAGUAR",
    "modelo": "S-TYPE",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLS450",
    "busquedas": "5"
  },
  {
    "marca": "NISSAN",
    "modelo": "STANZA",
    "busquedas": "5"
  },
  {
    "marca": "LEXUS",
    "modelo": "GS350",
    "busquedas": "5"
  },
  {
    "marca": "ACURA",
    "modelo": "TLX",
    "busquedas": "5"
  },
  {
    "marca": "SUBARU",
    "modelo": "TRIBECA",
    "busquedas": "5"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CORONA",
    "busquedas": "5"
  },
  {
    "marca": "SATURN",
    "modelo": "LS1",
    "busquedas": "5"
  },
  {
    "marca": "LEXUS",
    "modelo": "NX300",
    "busquedas": "5"
  },
  {
    "marca": "BUICK",
    "modelo": "LACROSSE",
    "busquedas": "5"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "RABBIT",
    "busquedas": "5"
  },
  {
    "marca": "SATURN",
    "modelo": "SL",
    "busquedas": "5"
  },
  {
    "marca": "FORD",
    "modelo": "TAURUS X",
    "busquedas": "5"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO SPORT",
    "busquedas": "5"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LITE ACE",
    "busquedas": "5"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CRUZE LIMITED",
    "busquedas": "5"
  },
  {
    "marca": "DAEWOO",
    "modelo": "NUBIRA",
    "busquedas": "5"
  },
  {
    "marca": "DODGE",
    "modelo": "ATTITUDE",
    "busquedas": "5"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G5",
    "busquedas": "5"
  },
  {
    "marca": "HONDA",
    "modelo": "PRELUDE",
    "busquedas": "5"
  },
  {
    "marca": "MAHINDRA",
    "modelo": "SCORPIO",
    "busquedas": "5"
  },
  {
    "marca": "JAC",
    "modelo": "X200",
    "busquedas": "5"
  },
  {
    "marca": "DODGE",
    "modelo": "RAIDER",
    "busquedas": "5"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 2500 VAN",
    "busquedas": "4"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE5",
    "busquedas": "4"
  },
  {
    "marca": "INFINITI",
    "modelo": "EX35",
    "busquedas": "4"
  },
  {
    "marca": "KIA",
    "modelo": "RIO5",
    "busquedas": "4"
  },
  {
    "marca": "NISSAN",
    "modelo": "370Z",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MALIBU LIMITED",
    "busquedas": "4"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "ATLAS",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "328CI",
    "busquedas": "4"
  },
  {
    "marca": "TOYOTA",
    "modelo": "VENZA",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C1500 SUBURBAN",
    "busquedas": "4"
  },
  {
    "marca": "FORD",
    "modelo": "E-150 ECONOLINE",
    "busquedas": "4"
  },
  {
    "marca": "ACURA",
    "modelo": "RL",
    "busquedas": "4"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "335D",
    "busquedas": "4"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK230",
    "busquedas": "4"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DISCOVERY SPORT",
    "busquedas": "4"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DEFENDER",
    "busquedas": "4"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "GRAND VOYAGER",
    "busquedas": "4"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX570",
    "busquedas": "4"
  },
  {
    "marca": "LEXUS",
    "modelo": "LS460",
    "busquedas": "4"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 2500",
    "busquedas": "4"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "BORA",
    "busquedas": "4"
  },
  {
    "marca": "PONTIAC",
    "modelo": "GRAND PRIX",
    "busquedas": "4"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK430",
    "busquedas": "4"
  },
  {
    "marca": "FORD",
    "modelo": "F-350",
    "busquedas": "4"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RAIZE",
    "busquedas": "4"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G3",
    "busquedas": "4"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR4",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 2500",
    "busquedas": "4"
  },
  {
    "marca": "DODGE",
    "modelo": "SPRINTER 2500",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "K1500",
    "busquedas": "3"
  },
  {
    "marca": "MAZDA",
    "modelo": "MX-5",
    "busquedas": "3"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 1500 VAN",
    "busquedas": "3"
  },
  {
    "marca": "SUBARU",
    "modelo": "WRX",
    "busquedas": "3"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA IM",
    "busquedas": "3"
  },
  {
    "marca": "FIAT",
    "modelo": "SIENA",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "540I",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 HD",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 LD",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 3500",
    "busquedas": "3"
  },
  {
    "marca": "FORD",
    "modelo": "AEROSTAR",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E550",
    "busquedas": "3"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE SELECT",
    "busquedas": "3"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CABRIO",
    "busquedas": "3"
  },
  {
    "marca": "LINCOLN",
    "modelo": "LS",
    "busquedas": "3"
  },
  {
    "marca": "INFINITI",
    "modelo": "G20",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CORSA",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "M3",
    "busquedas": "3"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX350L",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 3500 HD",
    "busquedas": "3"
  },
  {
    "marca": "SATURN",
    "modelo": "OUTLOOK",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "320I XDRIVE",
    "busquedas": "3"
  },
  {
    "marca": "AUDI",
    "modelo": "A3",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C280",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "335IS",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "UPLANDER",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "335XI",
    "busquedas": "3"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR3",
    "busquedas": "3"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "3000GT",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MONTE CARLO",
    "busquedas": "3"
  },
  {
    "marca": "GMC",
    "modelo": "ENVOY XL",
    "busquedas": "3"
  },
  {
    "marca": "FORD",
    "modelo": "E-150 ECONOLINE CLUB WAGON",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C240",
    "busquedas": "3"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER CLUBMAN",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "X7",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLC300",
    "busquedas": "2"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX450H",
    "busquedas": "2"
  },
  {
    "marca": "PONTIAC",
    "modelo": "GRAND AM",
    "busquedas": "2"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 3500 HD",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK EV",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "323CI",
    "busquedas": "2"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "DIAMANTE",
    "busquedas": "2"
  },
  {
    "marca": "SATURN",
    "modelo": "SKY",
    "busquedas": "2"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA CROSS",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK320",
    "busquedas": "2"
  },
  {
    "marca": "KIA",
    "modelo": "NIRO",
    "busquedas": "2"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-50",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "LUV",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "G20",
    "busquedas": "2"
  },
  {
    "marca": "SATURN",
    "modelo": "AURA",
    "busquedas": "2"
  },
  {
    "marca": "KIA",
    "modelo": "TELLURIDE",
    "busquedas": "2"
  },
  {
    "marca": "RAM",
    "modelo": "PROMASTER 1500",
    "busquedas": "2"
  },
  {
    "marca": "SATURN",
    "modelo": "SC1",
    "busquedas": "2"
  },
  {
    "marca": "PONTIAC",
    "modelo": "AZTEK",
    "busquedas": "2"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "AZERA",
    "busquedas": "2"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "206",
    "busquedas": "2"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER EVOQUE",
    "busquedas": "2"
  },
  {
    "marca": "JIM",
    "modelo": "REMAX",
    "busquedas": "2"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "I20",
    "busquedas": "2"
  },
  {
    "marca": "FORD",
    "modelo": "FIVE HUNDRED",
    "busquedas": "2"
  },
  {
    "marca": "DATSUN",
    "modelo": "PICKUP",
    "busquedas": "2"
  },
  {
    "marca": "SCION",
    "modelo": "IA",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CMP",
    "busquedas": "2"
  },
  {
    "marca": "SCION",
    "modelo": "FR-S",
    "busquedas": "2"
  },
  {
    "marca": "MAZDA",
    "modelo": "E2200",
    "busquedas": "2"
  },
  {
    "marca": "VOLVO",
    "modelo": "V70",
    "busquedas": "2"
  },
  {
    "marca": "FORD",
    "modelo": "C-MAX",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "T-CROSS",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S320",
    "busquedas": "2"
  },
  {
    "marca": "SUZUKI",
    "modelo": "VERONA",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL320",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLA250",
    "busquedas": "2"
  },
  {
    "marca": "EAGLE",
    "modelo": "TALON",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "NOVA",
    "busquedas": "2"
  },
  {
    "marca": "FORD",
    "modelo": "MAVERICK",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "TSURU",
    "busquedas": "2"
  },
  {
    "marca": "ISUZU",
    "modelo": "AXIOM",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TRANSPORTER",
    "busquedas": "2"
  },
  {
    "marca": "JAGUAR",
    "modelo": "XF",
    "busquedas": "2"
  },
  {
    "marca": "DAEWOO",
    "modelo": "LEGANZA",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E55 AMG",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "228I GRAN COUPE",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVEO5",
    "busquedas": "2"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 1500 CLASSIC",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "PULSAR NX",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "210",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOL",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "PASSAT CC",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "135I",
    "busquedas": "2"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "306",
    "busquedas": "2"
  },
  {
    "marca": "MERCURY",
    "modelo": "TOPAZ",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C200",
    "busquedas": "2"
  },
  {
    "marca": "LINCOLN",
    "modelo": "MKS",
    "busquedas": "2"
  },
  {
    "marca": "JEEP",
    "modelo": "WAGONEER",
    "busquedas": "2"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE XL",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL350",
    "busquedas": "2"
  },
  {
    "marca": "ACURA",
    "modelo": "ZDX",
    "busquedas": "1"
  },
  {
    "marca": "HONDA",
    "modelo": "CRX",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SONORA",
    "busquedas": "1"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SUPRA",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "A7",
    "busquedas": "1"
  },
  {
    "marca": "JAC",
    "modelo": "T8 PRO",
    "busquedas": "1"
  },
  {
    "marca": "CHERY",
    "modelo": "TIGGO 4 PRO",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS PASAJEROS",
    "busquedas": "1"
  },
  {
    "marca": "NISSAN",
    "modelo": "MARCH",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "325",
    "busquedas": "1"
  },
  {
    "marca": "ASTON MARTIN",
    "modelo": "DBS",
    "busquedas": "1"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS C",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CRAFTER",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "DAMAS/LABO",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "M5",
    "busquedas": "1"
  },
  {
    "marca": "RAM",
    "modelo": "DAKOTA",
    "busquedas": "1"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MR2 SPYDER",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "325IS",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "E-250 ECONOLINE",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "740IL",
    "busquedas": "1"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "GRAND VOYAGER",
    "busquedas": "1"
  },
  {
    "marca": "JMC",
    "modelo": "JX",
    "busquedas": "1"
  },
  {
    "marca": "INFINITI",
    "modelo": "G37",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "NIVUS",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S550",
    "busquedas": "1"
  },
  {
    "marca": "SATURN",
    "modelo": "SW2",
    "busquedas": "1"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GETZ",
    "busquedas": "1"
  },
  {
    "marca": "FIAT",
    "modelo": "124 SPIDER",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "A4 QUATTRO",
    "busquedas": "1"
  },
  {
    "marca": "MAXUS",
    "modelo": "D90",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "FIESTA IKON",
    "busquedas": "1"
  },
  {
    "marca": "RENAULT",
    "modelo": "SCENIC",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C3500",
    "busquedas": "1"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 3500",
    "busquedas": "1"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 1500",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "RAMCHARGER",
    "busquedas": "1"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "PRECIS",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "B250",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLA250",
    "busquedas": "1"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "3008",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SL550",
    "busquedas": "1"
  },
  {
    "marca": "LAMBORGHINI",
    "modelo": "MURCIELAGO",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "430I",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "VIRTUS",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "S5",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK550",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C1500",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "THUNDERBIRD",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK250",
    "busquedas": "1"
  },
  {
    "marca": "RENAULT",
    "modelo": "KANGOO",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK350",
    "busquedas": "1"
  },
  {
    "marca": "JEEP",
    "modelo": "COMANCHE",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SPRINTER",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "TT QUATTRO",
    "busquedas": "1"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-70",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK350",
    "busquedas": "1"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "BREEZE",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MATIZ",
    "busquedas": "1"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q60",
    "busquedas": "1"
  },
  {
    "marca": "VOLVO",
    "modelo": "V40 CROSS COUNTRY",
    "busquedas": "1"
  },
  {
    "marca": "VOLVO",
    "modelo": "V50",
    "busquedas": "1"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GENESIS",
    "busquedas": "1"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AGYA",
    "busquedas": "1"
  },
  {
    "marca": "MAZDA",
    "modelo": "MILLENIA",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "S10 BLAZER",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "ASPIRE",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLS350D",
    "busquedas": "1"
  },
  {
    "marca": "KIA",
    "modelo": "AMANTI",
    "busquedas": "1"
  },
  {
    "marca": "KIA",
    "modelo": "BORREGO",
    "busquedas": "1"
  }
];

export default preloadedTopVehicles;
